import React, { FC } from "react"
import { Link } from "react-router-dom"

import { Anchor, Button, Center } from "@mantine/core"
import { IconRefresh } from "@tabler/icons-react"

import SettingsCard from "../settings-card/SettingsCard"
import { useLanguage } from "../../../contexts/language-context"
import useSyncSetting from "./useSyncSetting"

const SyncSettingsCard: FC = () => {
    const { L } = useLanguage()
    const { onSync, processing } = useSyncSetting()

    return (
        <SettingsCard
            title={L("Synchronise app")}
            icon={IconRefresh}
            description={L(
                "The app will synchronise every night at 2:00. Although uncommon, it may happen that the dashboard gets out of date and changes are not reflected truthfully. In such cases, it might help to synchronise manually with the button below. If this does not resolve your issue, please contact %s.",
                <Anchor component={Link} to="https://ecomoni.nl/support">
                    {L("Ecomoni support")}
                </Anchor>,
            )}
        >
            <Center>
                <Button variant="outline" leftIcon={<IconRefresh size={20} />} onClick={onSync} loading={processing}>
                    {L("Synchronise with AWS")}
                </Button>
            </Center>
        </SettingsCard>
    )
}

export default SyncSettingsCard
